module.exports = __webpack_public_path__ + "static/media/chest-pain.59fbcf4e.svg";